export type SupportedGiftcardVatBookkeepingMethodType =
    | "AT_ISSUE"
    | "AT_REDEEM";
export const supportedGiftcardVatBookkeepingMethods: SupportedGiftcardVatBookkeepingMethodType[] =
    ["AT_ISSUE", "AT_REDEEM"];
